import { render, staticRenderFns } from "./AppListingServiceSectionsBlock.vue?vue&type=template&id=1a89b725&scoped=true"
import script from "./AppListingServiceSectionsBlock.vue?vue&type=script&lang=js"
export * from "./AppListingServiceSectionsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89b725",
  null
  
)

export default component.exports